import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-acc-checkbox',
  templateUrl: './acc-checkbox.component.html',
  styleUrls: ['./acc-checkbox.component.scss']
})
export class AccCheckboxComponent {

  @Input({ alias: 'formControl' }) public fc!: FormControl;
  @Input({ alias: 'formGroup' }) public fg!: FormGroup;

}
